import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { string, func, node, shape, oneOfType } = proptypes;

export const GroupItemAlert = ({ alert }) => {
  if (React.isValidElement(alert)) {
    return alert;
  }

  return <Alert status={alert.status}>{alert.render()}</Alert>;
};

GroupItemAlert.propTypes = {
  alert: oneOfType(
    [
      shape({
        status: string.isRequired,
        render: func,
      }),
      node
    ]
  ).isRequired,
};
